/**
 * Add a new record from template by replacing placeholder with unique index.
 * @param {Element} container - container to append to
 * @param {string} templateHTML - innerHTML of template
 * @param {string} [placeholder='NEW_INDEX'] - placeholder to replace (regex-safe)
 * @returns {Element | null} - the newly added element, or null
 */
export function addFromTemplate(container, templateHTML, placeholder = "NEW_INDEX") {
  const index = Date.now()
  const regex = new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g")
  const content = templateHTML.replace(regex, String(index))
  container.insertAdjacentHTML("beforeend", content)
  return container.lastElementChild
}
